import Vue from 'vue';
import Vuex from 'vuex';
import appModule from './modules/app';
import favouritesModule from './modules/favourites';
import menuModule from './modules/menu';
import uiModule from './modules/ui';
import myPropositionsModule from './modules/myPropositions';
import handleSubscriptionModule from './modules/handleSubscription';
import overlayModule from './modules/overlay';
import propositionSwitcherModule from './modules/propositionSwitcher';
import screenSizeModule from './modules/screenSize';
import trialModule from './modules/trial';
import klarnaPaymentsModule from './modules/klarnaPayments';
import paymentHistoryModule from './modules/paymentHistory';
import swapListModule from './modules/swapList';
import propositionsModule from './modules/propositions';
import interestsModule from './modules/interests';
import toastModule from './modules/toast';
import searchModule from './modules/search';
import wishAreasModule from './modules/wishAreas';
import gtmModule from './modules/gtm';
import notificationCenterModule from './modules/notificationCenter';
import extraVisibility from './modules/extraVisibility';
import superLikes from './modules/superLikes';
import payment from './modules/payment';
import matches from './modules/matches';
import matches2 from './modules/matches2';
import startAnimation from './modules/startAnimation';
import reportProposition from './modules/reportProposition';
import signup from './modules/signup';
import suggestionsMap from './modules/suggestionsMap';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    app: appModule,
    gtm: gtmModule,
    favourites: favouritesModule,
    menu: menuModule,
    ui: uiModule,
    myPropositions: myPropositionsModule,
    handleSubscription: handleSubscriptionModule,
    overlay: overlayModule,
    propositionSwitcher: propositionSwitcherModule,
    screenSize: screenSizeModule,
    trial: trialModule,
    klarnaPayments: klarnaPaymentsModule,
    paymentHistory: paymentHistoryModule,
    swapList: swapListModule,
    propositions: propositionsModule,
    interests: interestsModule,
    toast: toastModule,
    search: searchModule,
    wishAreas: wishAreasModule,
    notificationCenter: notificationCenterModule,
    extraVisibility,
    superLikes,
    payment,
    matches,
    matches2,
    startAnimation,
    reportProposition,
    signup,
    suggestionsMap
  },
  plugins: [
    createPersistedState({
      paths: ['signup']
    })
  ]
});
